import { Element, ContentOverlay, Toast } from '@chaysehartsuff/active-html';
import { Table } from '@chaysehartsuff/active-html';
import { FieldType } from '@chaysehartsuff/active-html';
import {FormatType} from '@chaysehartsuff/active-html';
import Blog from '../../models/Blog.js';
import User from '../../models/User.js';

export default class BlogList extends Element {

    constructor(tableId){
        super();

        const is_admin = new User().role_level == 1; 
        
        this.table = new Table(tableId, new Blog(), [
            {
                label:"ID",
                name: "id",
                sortable: true,
                searchable: false,
                visible: false,
                editable: false,
                type: FieldType.NUMBER
            },
            {
                label:"User ID",
                name: "user_id",
                searchable: false,
                visible: false,
                editable: false,
                type: FieldType.NUMBER
            },
            {
                label:"Title",
                name: "title",
                sortable: true,
                searchable: true,
                type: FieldType.STRING
            },
            {
                label:"Description",
                name: "description",
                sortable: false,
                searchable: true,
                type: FieldType.STRING
            },
            {
                label: "Published",
                name: "is_published",
                sortable: true,
                searchable: true,
                use_in_default_search: false,
                type: FieldType.BOOLEAN
            },
            {
                label: "Author",
                name: "author",
                sortable: true,
                searchable: true,
                visible: false,
                use_in_default_search: false,
                type: FieldType.STRING,
                hideable: true
            },
            {
                label:"Date",
                name: "publish_date",
                sortable: true,
                searchable: true,
                use_in_default_search: false,
                type: FieldType.DATE,
            }
        ], {
            [FieldType.DATE]: FormatType.DATE.FULL_TEXT
        }, {
            sort_columns: [
                {
                    key: 'publish_date',
                    direction: 'desc'
                }
            ]
        }, {
            show_hideable_columns: is_admin,
        });
        this.table.addRowAction('delete','Delete', this.onRowDelete.bind(this));
        this.bindToDom();
    }

    onRowDelete(row) {
        let overlay = new ContentOverlay(
            new Element()
                .addClass('w-full max-w-xl rounded-xl bg-white p-10 shadow-2xl')
                .addContent(
                    new Element('h2')
                        .addClass('mb-5 text-lg font-semibold text-slate-900')
                        .addContent('Delete Blog')
                )
                .addContent(
                    new Element('p')
                        .addClass('mb-5 text-sm text-slate-600')
                        .addContent(`Are you sure you want to delete (and unpublish) this blog? "${row.title}".`)
                )
                .addContent(
                    new Element().addClass('flex justify-around items-center')
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('rounded-lg bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-200')
                                .addContent('Cancel')
                                .onEvent('click', () => {
                                    this.removeContent('delete-blog');
                                })
                        )
                        .addContent(
                            new Element('button')
                                .setAttribute('type', 'button')
                                .addClass('rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-700')
                                .addContent('Delete')
                                .onEvent('click', () => {
                                    let blog = new Blog();
                                    blog.id = row.id;
                                    blog.getSync();

                                    blog.delete({}, function(response){
                                        this.removeContent('delete-blog');
                                        this.table.fetchRows();

                                        const errors = response?.errors;
                                        const firstErrorGroup = Array.isArray(errors) ? errors[0] : Object.values(errors || {})[0];
                                        const firstErrorMessage = Array.isArray(firstErrorGroup) ? firstErrorGroup[0] : firstErrorGroup;

                                        if(firstErrorMessage){
                                            new Toast('Error deleting blog: ' + firstErrorMessage).error();
                                        } else {
                                            new Toast('Blog deleted successfully').success();
                                        }
                                    }.bind(this));

                                })
                        )
                )
        );
        this.addContent(overlay, 'delete-blog');
    }
}